module.exports = __webpack_public_path__ + "img/g2_senlinS686.253ba845.jpg";